import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Rajesh Kumar',
      role: 'Homeowner',
      location: 'Mumbai',
      rating: 5,
      text: 'Excellent service! The technicians were professional, arrived on time, and installed my new split AC perfectly. Highly recommend Coolant Air Systems.',
      image: 'https://ui-avatars.com/api/?name=Rajesh+Kumar&background=0B4CBF&color=fff&size=80'
    },
    {
      name: 'Priya Sharma',
      role: 'Business Owner',
      location: 'Pune',
      rating: 5,
      text: 'We have an AMC contract with them for our office. Their maintenance service is top-notch, and we have never faced any issues. Very satisfied!',
      image: 'https://ui-avatars.com/api/?name=Priya+Sharma&background=3ED3F7&color=fff&size=80'
    },
    {
      name: 'Amit Patel',
      role: 'Residential Complex Manager',
      location: 'Delhi',
      rating: 5,
      text: 'Coolant Air Systems handled the HVAC installation for our entire residential complex. Their team was efficient, and the pricing was very competitive.',
      image: 'https://ui-avatars.com/api/?name=Amit+Patel&background=0B4CBF&color=fff&size=80'
    },
    {
      name: 'Neha Desai',
      role: 'Homeowner',
      location: 'Bangalore',
      rating: 5,
      text: 'Quick response for AC repair! My AC stopped working during peak summer, and they fixed it within hours. Great service and genuine parts used.',
      image: 'https://ui-avatars.com/api/?name=Neha+Desai&background=3ED3F7&color=fff&size=80'
    },
    {
      name: 'Vikram Singh',
      role: 'Restaurant Owner',
      location: 'Hyderabad',
      rating: 5,
      text: 'Professional team with excellent technical knowledge. They recommended the perfect commercial AC solution for our restaurant. Very happy with the installation.',
      image: 'https://ui-avatars.com/api/?name=Vikram+Singh&background=0B4CBF&color=fff&size=80'
    },
    {
      name: 'Sunita Rao',
      role: 'Homeowner',
      location: 'Chennai',
      rating: 5,
      text: 'Best AC service provider in the city! From consultation to installation, everything was smooth. The after-sales support is also excellent.',
      image: 'https://ui-avatars.com/api/?name=Sunita+Rao&background=3ED3F7&color=fff&size=80'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">Testimonials</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers have to say about our services.
          </p>
        </div>

        {/* Testimonials grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={index}
              className="group hover:shadow-xl transition-all duration-300 border-0 bg-white relative overflow-hidden"
            >
              {/* Quote icon decoration */}
              <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity">
                <Quote size={80} className="text-primary" />
              </div>

              <CardContent className="p-6 space-y-4 relative z-10">
                {/* Rating */}
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={18} className="fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Testimonial text */}
                <p className="text-gray-700 leading-relaxed italic">
                  "{testimonial.text}"
                </p>

                {/* Customer info */}
                <div className="flex items-center gap-4 pt-4 border-t border-gray-200">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-14 h-14 rounded-full border-2 border-primary"
                  />
                  <div>
                    <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                    <p className="text-xs text-primary font-semibold">{testimonial.location}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust badges */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2">500+</div>
            <div className="text-sm text-gray-600">Happy Clients</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2">4.9/5</div>
            <div className="text-sm text-gray-600">Average Rating</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2">98%</div>
            <div className="text-sm text-gray-600">Satisfaction Rate</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-primary mb-2">24/7</div>
            <div className="text-sm text-gray-600">Support Available</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
